import TablePagination from '@mui/material/TablePagination';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import teamService from '../../../services/teamsService';

import { teamsStore } from '../../../stores';

type Props = {
  teamsStore: typeof teamsStore;
  distance_id: number;
  switchedOnTop: boolean;
};

const PaginationComponent = ({ teamsStore, distance_id, switchedOnTop }: Props) => {
  const { paginationMeta } = teamsStore;
  const page = teamsStore.page;
  const { per_page, total } = paginationMeta;

  return (
    <TablePagination
      component='div'
      count={total || 0}
      rowsPerPage={per_page || 30}
      className={classnames({ pagination: !switchedOnTop })}
      classes={{
        selectLabel: 'caption',
        displayedRows: 'caption',
        select: 'choose-num',
        selectIcon: 'choose-num-svg',
      }}
      rowsPerPageOptions={[30, 50, 100, 200]}
      page={page - 1}
      backIconButtonProps={{
        'aria-label': 'Previous Page',
      }}
      nextIconButtonProps={{
        'aria-label': 'Next Page',
      }}
      onPageChange={(event, page) => {
        teamService.loadResources(distance_id, {}, page + 1);
      }}
      onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        teamService.loadResources(distance_id, { limit: Number(event.target.value) });
      }}
    />
  );
};

export const Pagination = observer(PaginationComponent);
